import { ButtonHTMLAttributes, forwardRef, ReactNode } from "react";
import { cn } from "@/lib/cn";

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  label: string; // a11y label
  children: ReactNode;
}

export const IconButton = forwardRef<HTMLButtonElement, Props>(function IconButton(
  { label, className, children, ...rest }, ref
) {
  return (
    <button
      ref={ref}
      aria-label={label}
      title={label}
      className={cn(
        "inline-flex items-center justify-center size-8 rounded",
        "text-text-muted hover:text-text hover:bg-bg-subtle",
        "transition-colors duration-150",
        className,
      )}
      {...rest}
    >
      {children}
    </button>
  );
});
